// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  kenticoConfig: {
    projectId: 'd2485dfd-f457-420a-81aa-2c17b1521380',
    previewApiKey: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJ1c3JfMHZXcFhkcDllckRPN1lYMDVWZHRBMyIsImVtYWlsIjoibGVya0BncmlkaGF1cy5jb20iLCJwcm9qZWN0X2lkIjoiZDI0ODVkZmQtZjQ1Ny00MjBhLTgxYWEtMmMxN2IxNTIxMzgwIiwianRpIjoibGlSVHVkWEFzVHFQUmRIQiIsInZlciI6IjEuMC4wIiwiZ2l2ZW5fbmFtZSI6IkVuIExlcmsiLCJmYW1pbHlfbmFtZSI6IkxhdyIsImF1ZCI6InByZXZpZXcuZGVsaXZlci5rZW50aWNvY2xvdWQuY29tIn0.HtvPpihAUYavSyKXnGCyXat5u21AlVRiaZpprF3Xu7Y',
  },
};



// WEBPACK FOOTER //
// /opt/build/repo/src/environments/environment.ts